import Link from "@material-ui/core/Link";
import { useTranslate } from "react-admin";

import { FinancialChartsDataGrid } from "./FinancialChartsDataGrid";

export const OrdersDatagrid = ({ orders }) => {
	const translate = useTranslate();

	const columns = [
		{
			key: "order_id",
			label: translate("resources.financial-statements.order-grid.fields.order_id"),
		},
		{
			key: "eta_date",
			label: translate("resources.financial-statements.order-grid.fields.eta_date"),
		},
		{
			key: "etd_date",
			label: translate("resources.financial-statements.order-grid.fields.etd_date"),
		},
		{
			key: "reference",
			label: translate("resources.financial-statements.order-grid.fields.reference"),
			render: (value, row) => (
				<Link href={`#/orders/${row.order_id}/show`} target="_blank">
					{value}
				</Link>
			),
		},
		{
			key: "terminal_id",
			label: translate("resources.financial-statements.order-grid.fields.terminal_id"),
		},
		{
			key: "order_cost",
			label: translate("resources.financial-statements.order-grid.fields.revenue"),
		},
	];

	return (
		<FinancialChartsDataGrid rows={orders} columns={columns} getRowKey={(row) => row.order_id} />
	);
};
